import {
  login,
  loginByAlipay,
  unBind,
  getInfo
} from '@/api/user'
import {
  getToken,
  setToken,
  removeToken,
  getLoginMode,
  setLoginMode,
  removeLoginMode
} from '@/utils/auth'
import router, {
  resetRouter
} from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  agentId: 0,
  loginMode: getLoginMode() // openid or password
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_AgentId: (state, agentId) => {
    state.agentId = agentId
  },
  SET_LoginMode: (state, loginMode) => {
    state.loginMode = loginMode
  }
}

const actions = {
  // user login by openid/user_id
  login({
    commit
  }, code) {
    return new Promise((resolve, reject) => {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/Alipay/i) == "alipay") {
        loginByAlipay({
          auth_code: code
        }).then(response => {
          const {
            data
          } = response
          if (data.token) {
            commit('SET_TOKEN', data.token)
            setToken(data.token)
            commit('SET_LoginMode', 'user_id')
            setLoginMode('user_id')
          }
          resolve(response)
        })
      } else {
        login({
          code
        }).then(response => {
          const {
            data
          } = response
          if (data.token) {
            commit('SET_TOKEN', data.token)
            setToken(data.token)
            commit('SET_LoginMode', 'openid')
            setLoginMode('openid')
          }
          resolve(response)
        })
      }
    })
  },

  loginByPassword({
    commit
  }, loginForm) {
    return new Promise((resolve, reject) => {
      login(loginForm).then(res => {
        if (res.code != 0) {
          reject(res.msg)
          return
        }
        commit('SET_TOKEN', res.data.token)
        setToken(res.data.token)
        commit('SET_LoginMode', 'password')
        setLoginMode('password')
        resolve(res)
      })
    })
  },

  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(res => {
        if (res.code != 0) {
          reject(res.msg)
          return
        }
        if (!res.data.roles || res.data.roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
          return
        }
        commit('SET_ROLES', res.data.roles)
        commit('SET_NAME', res.data.name)
        commit('SET_AVATAR', res.data.avatar)
        commit('SET_INTRODUCTION', res.data.introduction)
        commit('SET_AgentId', res.data.agent_id)
        resolve(res.data)
      })
    })
  },

  unBind({
    commit,
    state,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      unBind(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        commit('SET_LoginMode', '')
        removeLoginMode()
        resetRouter()
        dispatch('tagsView/delAllViews', null, {
          root: true
        })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  logout({
    commit,
    state,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      commit('SET_LoginMode', '')
      removeLoginMode()
      resetRouter()
      dispatch('tagsView/delAllViews', null, {
        root: true
      })
      resolve()
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      commit('SET_LoginMode', '')
      removeLoginMode()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({
    commit,
    dispatch
  }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const {
      roles
    } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, {
      root: true
    })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, {
      root: true
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js